export default __webpack_public_path__ + "static/media/contract.cb52a454.png";